<template>
  <div>
    <div id="section-to-print">
      <v-row type="flex" class="row-bg fTitle" style="text-align: right">
        <v-col cols="6" md="6" sm="6" style="padding:0px !important;">
          <v-img style="height: 70px;float: left;" src="../../../assets/logo.jpg" contain></v-img>
        </v-col>
        <v-col cols="6" md="6" sm="6" style="padding:0px !important;">
          ទម្រង់ផ្ទៀងផ្ទាត់ស្តុក
          <span style="font-size: 12px"><br>Inventory Reconciliation Form</span>
        </v-col>
      </v-row>
      <hr style="border-top: 1px double">

      <v-row type="flex" class="row-bg" justify="center">
        <v-col style="padding: 0px !important;" cols="12" md="12" sm="12"></v-col>
        <v-col sm="3" md="3" lg="3" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '3'"
               style="padding-top: 0px !important;padding-bottom: 0px !important;">
          ឈ្មោះម្ចាស់ទីតាំង ៖ {{ stockReconcileDetail && stockReconcileDetail.client_name || $t('all') }}

        </v-col>
        <v-col cols="3" sm="3" md="3" style="padding: 0px!important;">
          <td style="padding: 0px !important;">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        v-model="isBeedepo"
                        label="ប៊ីដេប៉ូ" readonly
            ></v-checkbox>
          </td>
          <td style="padding: 0px !important;">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        v-model="isBeeshop"
                        label="ប៊ីសប" readonly
            ></v-checkbox>
          </td>
          <td style="padding: 0px !important;">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        v-model="isBeexpress"
                        label="ប៊ីអ៊ិចប្រេស" readonly
            ></v-checkbox>
          </td>
        </v-col>

        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'"
               style="padding-top: 0px !important;padding-bottom: 0px !important;">
          អាសយដ្ឋាន ៖ {{ stockReconcileDetail && stockReconcileDetail.client_full_location || $t('all') }}
        </v-col>
        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'"
               style="padding-top: 0px !important;padding-bottom: 0px !important;">
          ឈ្មោះមន្រ្តីប្រតិបត្តិការមូលដ្ឋាន ៖ {{
            stockReconcileDetail && stockReconcileDetail.operator_name || $t('all')
          }}
        </v-col>
        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'"
               style="padding-top: 0px !important;padding-bottom: 0px !important;">
          លេខទូរស័ព្ទ ៖ {{ stockReconcileDetail && stockReconcileDetail.phone || "" }}
        </v-col>
        <v-col style="padding: 0px !important;" cols="6" md="6" sm="6"></v-col>
        <v-col cols="12" style="overflow-x: auto;display: block;white-space: nowrap;">
          <table class="report">
            <thead>
            <tr>
              <th>{{ $t("n0") }}</th>
              <th>{{ $t("item") }}</th>
              <th>{{ $t("unit") }}</th>
              <th>{{ $t("beginQty") }}</th>
              <th>{{ $t("stockIn") }}</th>
              <th>{{ $t("stockOut") }}</th>
              <th style="text-align: center">{{ $t("endingQty") }}</th>
              <th style="text-align: right">{{ $t("other") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(doc,j) in stockReconcileDetail && stockReconcileDetail.transaction_reconcile_lines || []"
                :key="j">
              <td style="text-align: center">{{ j + 1 }}</td>
              <td>{{ doc.sku }} : {{ doc.product_name }}</td>
              <td style="text-align: center">{{ doc.unit_name }}</td>
              <td style="text-align: center">{{ doc.qty_on_hand | formatNumber }}</td>
              <td style="text-align: center">
                {{ (doc.qty > doc.qty_on_hand ? doc.qty - doc.qty_on_hand : 0) | formatNumber }}
              </td>
              <td style="text-align: center">
                {{ (doc.qty_on_hand > doc.qty ? doc.qty_on_hand - doc.qty : 0) | formatNumber }}
              </td>
              <td style="text-align: center">{{ doc.qty | formatNumber }}</td>
              <td>{{ doc.note || "" }}</td>

            </tr>
            </tbody>

          </table>
          <table>
            <tr>
              <td style="text-align: center;">ពិនិត្យ និងយល់ព្រម<br>ម្ចាស់ប៊ីដេប៉ូ/ប៊ីសប/ប៊ីអ៊ិចប្រេស</td>
              <td style="text-align: center">ផ្ទៀងផ្ទាត់ដោយ<br>មន្រ្តីប្រតិបត្តិការមូលដ្ឋាន</td>
            </tr>
            <br><br>
            <tr>
              <td style="text-align: center"><span style="border-top: 1px solid;">កាលបរិច្ឆេទ ៖ ......./................/..........</span>
              </td>
              <td style="text-align: center"><span style="border-top: 1px solid">កាលបរិច្ឆេទ ៖ ......./................/...........</span>
              </td>
            </tr>

          </table>
        </v-col>
      </v-row>

      <div class="footer-right">
        <p>Inventory Reconciliation Form-V0 {{ today }}</p>
      </div>
    </div>


  </div>

</template>

<script>
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import ReportDataMixin from "../../../mixins/reportDataMixin";
import moment from "moment"

export default {
  components: {},
  mixins: [ValidatorMixin, OptionDataMixin, ReportDataMixin],
  data() {
    return {
      valid: false,
      loadingReport: false,
      loadingSubmit: false,
      memberName: "",
      token: "",
      stockReconcileDetail: {},
      today: "",
      isBeedepo: false,
      isBeeshop:false,
      isBeexpress:false
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    }
  },
  watch: {},
  computed: {
    userDoc() {
      return true;
      //return this.$store.state.userDoc;
    },
  },
  created() {
    let vm = this;
    vm.today = moment().format("YYYYMMDD");
    vm.stockReconcileDetail = vm.$route.params.stockReconcileDoc;
    vm.isBeedepo = vm.stockReconcileDetail && vm.stockReconcileDetail.client_type === 'beedepo';
    vm.isBeeshop = vm.stockReconcileDetail && vm.stockReconcileDetail.client_type === 'beeshop';
    vm.isBeexpress = vm.stockReconcileDetail && vm.stockReconcileDetail.client_type === 'beexpress';
  }
}
</script>